import DataGridRotateEffects from '../Cooperative/DataGridRotateEffects';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { sendEvent } from 'utils/Event';
import { toast } from 'react-toastify';
import useToggleSwitch from 'utils/hooks/useToggleSwitch';

const RotateEffectsDataGridExploitation = ({ exploitation, setExploitation, from, cultures }) => {
  const [exploit, setExploit] = useState(exploitation);
  const navigate = useNavigate();
  const exploitId = exploit?.id ?? +localStorage.getItem('exploitation');

  const { isOrganic } = useToggleSwitch(from, 'rotateEffects', () => {}, exploitId, null, null);

  useEffect(() => {
    loadData();
    return () => {
      sendEvent('cancelHttpRequest');
    };
  }, []);

  const loadData = () => {
    if (localStorage.getItem('exploitation')) {
      setExploitation(isOrganic, exploitId)
        .then((resp) => setExploit(resp.data.data))
        .catch((err) => toast.error(err.data));
    } else {
      toast.info('Selectionnez une exploitation');
      navigate('/exploitation');
    }
  };

  return (
    <DataGridRotateEffects
      from={from}
      cultures={cultures?.data?.filter((culture) => culture.isCustomized === true)}
      refreshData={setExploitation}
      ownerId={exploitId}
    />
  );
};

export default RotateEffectsDataGridExploitation;
